const state = {
  noticeCount: 0
}

const mutations = {
  SET_NOTICE_COUNT: (state, count) => {
    state.noticeCount = count
  }
}

const actions = {
  setNoticeCount({ commit }, count) {
    commit('SET_NOTICE_COUNT', count)
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
